import classes from '../styles/Page.module.scss';
import client from './api/graphql';
import { GET_PARTNERS_CONTENT } from './api/graphql/queries';
import CtaContentImageBlock from '../components/organisms/ctaContentImageBlock/CtaContentImageBlock';
import IconCopyCardListBlock from '../components/organisms/iconCopyCardListBlock/IconCopyCardListBlock';
import IconCardListBlock from '../components/organisms/iconCardListBlock/IconCardListBlock';
// import CtaOneColumnBlock from '../components/organisms/ctaOneColumnBlock/CtaOneColumnBlock';
import CtaList from '../components/organisms/ctaList/CtaList';
// import ImageTitleUrlCarousel from '../components/organisms/imageTitleUrlCarousel/ImageTitleUrlCarousel';
// import carouselSettings from '../components/organisms/imageTitleUrlCarousel/config/carouselSettings.json';
import TwoColumnImageWebForm from '../components/sections/twoColumnImageWebForm/TwoColumnImageWebForm';
import { redirectedPtAndArToEnglish } from '../utils/functions';

/**
 * Ayoba Web Partner Page
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const PartnerPage = (props) => {
    /**
     * Section content
     */
    const { partner } = props?.data;
    const { page_header, what_sets_us_apart, platform_features, feedback } =
        partner?.data?.attributes;
    const { 4: ComponentContentCardTheme, 5: ComponentListCtaList } = what_sets_us_apart;
    const blockTheme = ComponentContentCardTheme.custom_class;
    // const carouselElement = brands[1].brand_logos;

    return (
        <div className={`${classes.oChatbotPage} ${classes.oPage}`}>
            <CtaContentImageBlock {...page_header} />
            {/* <ImageTitleUrlCarousel
                contentModule={brands}
                carouselItem={carouselElement}
                config={carouselSettings}
            /> */}
            <IconCopyCardListBlock {...what_sets_us_apart} />
            <div className="container">
                <div className="row no-gutters">
                    <CtaList contentModule={ComponentListCtaList} customClass={blockTheme} />
                </div>
            </div>
            <IconCardListBlock {...platform_features} />
            <div id="contact"></div>
            <TwoColumnImageWebForm {...feedback} type="Partner" />
            {/* <CtaOneColumnBlock {...subfooter} /> */}
        </div>
    );
};

export async function getServerSideProps(context) {
    let locale = context.query?.lang || context.defaultLocale;
    locale = redirectedPtAndArToEnglish(locale)

    const { data } = await client.query({
        query: GET_PARTNERS_CONTENT,
        variables: { _locale: locale }
    });

    return {
        props: { data }
    };
}

export default PartnerPage;
